const styles = (theme) => ({
  timeLimitsContainer: {
    marginBottom: theme.spacing(2),
  },
  timeLimitsTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  timeLimitRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    '& > *:not(:last-child)': {
        marginRight: theme.spacing(2),
    },
    '@media (max-width: 600px)': {
        '& > *': {
            marginTop: theme.spacing(2),
        },
        '& > *:first-child': {
            marginTop: 0,
        },
        '& > *:nth-child(2)': {
            marginTop: 0,
        },
    },
  },
  numberInputWrapper: {
    width: 95,
    maxWidth: 95,
    flexShrink: 0,
    '@media (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  unitSelectWrapper: {
    flexGrow: 1,
    minWidth: '100%',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      minWidth: 120,
      width: 'auto',
    },
    '@media (max-width: 600px)': {
      width: 'calc(100% - 40px)', // Account for remove button width + margin
    },
  },
  unitSelect: {
    width: '100%',
    padding: '14px',
    paddingRight: '30px',
    appearance: 'none',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 10,
    backgroundColor: 'white',
    fontSize: '1rem',
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.primary.dark,
    },
  },
  selectArrow: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
  },
  removeButton: {
    color: 'white',
    backgroundColor: theme.palette.accentRed.main,
    padding: 0,
    marginLeft: 'auto',
    width: 24,
    height: 24,
    minWidth: 24,
    '&:hover': {
      backgroundColor: theme.palette.accentRed.dark,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
  addButton: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    border: 'none',
    borderRadius: 10,
    padding: theme.spacing(1.5),
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white', 
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1),
    },
    '& .MuiButton-label': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  addIcon: {
    color: theme.palette.primary.main,
    transition: 'color 0.3s ease',
  },
});

export default styles;
